<template>
  <div>
    <app-header />
    <div class="slideshow">
      <div class="slideshow-image"></div>
      <div class="slideshow-image"></div>
      <div class="slideshow-image"></div>
    </div>
    <div class="cont">
      <div class="cont-txt">
        <h2>AI健康认知大脑</h2>
        <h2>让机器变得更智能</h2>
        <p>用AI认知计算技术、配合人类进行健康和医疗诊断、分析工作<br />解决人脑不擅长解决的一些问题</p>
      </div>
      <div class="cont-but">
        <!-- <a href="../aiimp/index.html">产品列表</a> -->
        <router-link to="/ica" class="buton">智能认知分析</router-link>
        <!-- <a href="symp-opt.html" class="buton">智能认知分析</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import header from '@/components/header'

export default {
  name: "healthy",
  inject: ['reload'],
  data () {
    return {
    }
  },
  components: {
    'app-header': header,
  },
  mounted () {
  
  
   
  },
  methods: {

  },
}
</script>

<style>
@import "../assets/css/all.css";
@import "../assets/css/pagestyle.css";
</style>



// WEBPACK FOOTER //
// src/components/healthy.vue